import { Table } from "antd"
import { useSelector } from "react-redux"
import CustomButton from "../../../components/CustomButton"

const CompareForm1 = ({ setViewBlock }) => {
    const { compareObjectsForm1, isLoadingCompare } = useSelector(state => state.projectReducer)

    return <div className="compare__form__wrapper">
        <div className="compare__form__wrapper__header">
            <CustomButton
                onClick={() => setViewBlock("default")}
                type="grey"
            >
                Закрыть
            </CustomButton>
        </div>
        <Table
            dataSource={compareObjectsForm1?.ptmLevel12s}
            pagination={false}
            loading={isLoadingCompare}
            scroll={{
                x: 300
            }}
            bordered
            rowClassName={(record) => record.rePTMCode?.split("-").length < 2 || record.rePTMCode?.split("-").includes("99") ? 'row_bold_text'  : '' }
        >
            <Table.Column
                title="Код ПТМ"
                dataIndex="rePTMCode"
                width='10%'
                render={(code, record) => record.notShowCode ? null : code}
            />
            <Table.Column
                title="Наименование группы затрат"
                dataIndex="rePTMName"
                width='250px'
                fixed='left'
            />
            <Table.ColumnGroup
                title="Стоимостной показатель в руб. на 1 м2 общей площади"
            >

                {compareObjectsForm1?.analogObjects?.length ? compareObjectsForm1.analogObjects?.map((obj, index) => {
                    return <Table.Column
                        title={obj.analogObjectName}
                        key={obj.analogObjectName + index}

                        render={(text, record) => {
                            return compareObjectsForm1?.summaryCosts?.find(sc => sc.analogObjectId === obj.analogObjectId && record.rePTMCode === sc.rePTMCode && record.rePTMCode !== "2" && record.rePTMCode !== "3")?.cost
                        }}
                        width={'250px'}
                    />
                }) : null}
            </Table.ColumnGroup>
        </Table>
    </div>
}

export default CompareForm1
